<div class="p-6">
  <app-table [config]="chargeSetupTableConfig" [data]="chargeSetupList"
             [(selectedElements)]="selectedElements"></app-table>

  @if (selectedElements.length > 0) {
    <app-card>

      <div class="bg-gray-100 dark:bg-dark-hover py-2 px-3 rounded-md font-semibold">
        {{ 'chargeSetup.information' | translate }}
      </div>
      <div class="w-1/3">
        <app-value-details
          [collection]="chargeSetupData"
          [data]="selectedElements[0]"
        ></app-value-details>
      </div>

    </app-card>
  }
</div>
